/* eslint-disable */
import type { LocalizedString } from "../localization/localization.pb";
import type { Image } from "../ui/Image.pb";

/** A proto describing the Paychecks Home Ui */
export interface PaychecksHomeUi {
  /** An ordered list of Sections that should appear in the Paychecks Home */
  sections?: PaychecksHomeUiSection[];
}

/** An enumeration of the criteria we use for showing a section or not */
export enum PaychecksHomeUiSectionVisibilityPredicate {
  /**
   * DO_NOT_USE_CLIENT_COULD_NOT_PARSE_ENUM - If the client encounters this case, we will fall back to
   * ALWAYS_VISIBLE and log a nonfatal to indicate we've made
   * non-backwards-compatible proto changes.
   */
  DO_NOT_USE_CLIENT_COULD_NOT_PARSE_ENUM = "DO_NOT_USE_CLIENT_COULD_NOT_PARSE_ENUM",
  ALWAYS_VISIBLE = "ALWAYS_VISIBLE",
  VISIBLE_IF_CURRENT_DISTRIBUTION_SET = "VISIBLE_IF_CURRENT_DISTRIBUTION_SET",
  VISIBLE_IF_NO_CURRENT_DISTRIBUTION_SET = "VISIBLE_IF_NO_CURRENT_DISTRIBUTION_SET",
}

/** Values to be used in the Activity Section of Paychecks Home */
export interface PaychecksHomeUiActivitySection {
  /** A client route to load the entire activity history */
  view_all_button_client_route?: string;
  /** Section title */
  title?: LocalizedString;
  /** The text to use when the client has received an empty activity payload */
  no_activity_subtitle?: LocalizedString;
  /** The text to use when the client has failed to load activity */
  load_failure_subtitle?: LocalizedString;
  /** The text to use inside of the button to view the full activity history */
  view_all_button_title?: LocalizedString;
  /** The section title to show when the activity being shown is stale/oudated */
  stale_activity_title?: LocalizedString;
}

/** Values to be used in the NUX section of Paychecks Home */
export interface PaychecksHomeUiDistributionNUXSection {
  /** An image to display at the top of the section */
  header_image?: Image;
  /** A client route to follow when tapping on the CTA */
  call_to_action_client_route?: string;
  /** The text to use in a label just beneath the header image */
  title?: LocalizedString;
  /** The text to use in a label just beneath the title label */
  subtitle?: LocalizedString;
  /** The text to use in the call to action text (text link) */
  call_to_action_text?: LocalizedString;
}

/** Values to be used in the Active Distribution section */
export interface PaychecksHomeUiActiveDistributionSection {
  /** A client route to follow when tapping the "Edit" button */
  edit_button_client_route?: string;
  /** Text to be used in the title label, which is top-left aligned */
  title_text?: LocalizedString;
  /** Text to be used in the "Edit" button, which is top-right aligned */
  edit_button_text?: LocalizedString;
}

/** A section with a single call to action to add or update DD info */
export interface PaychecksHomeUiAddOrUpdateDirectDepositSection {
  /** A client route to follow when tapping the "Add or update direct deposit" button */
  button_client_route?: string;
  /** The text to be used in the CTA */
  button_text?: LocalizedString;
}

/** A description of a single section and visibility predicate in the Paychecks Home */
export interface PaychecksHomeUiSection {
  /** The criteria to determine the visibility of a section. */
  visibility_predicate?: PaychecksHomeUiSectionVisibilityPredicate;
  activity?: PaychecksHomeUiActivitySection | undefined;
  nux?: PaychecksHomeUiDistributionNUXSection | undefined;
  active_distribution?: PaychecksHomeUiActiveDistributionSection | undefined;
  add_or_update_direct_deposit?: PaychecksHomeUiAddOrUpdateDirectDepositSection | undefined;
}
